module.exports = __webpack_public_path__ + "static/media/mcf.d309ea32.png";